import React, { useEffect } from "react";
import { connect } from "react-redux";
import { createSelector } from "reselect";
import { bindDispatch } from "../../../../../utils";
import Summary from "../../common/Summary";

export const CampaignSummary = ({
  campaignId,
  actions: { getCampaignSummary },
  campaigns: { campaignSummary, isTabLoading },
}) => {
  useEffect(() => {
    getCampaignSummary(campaignId);
  }, [campaignId, getCampaignSummary]);

  return <Summary isLoading={isTabLoading} summary={campaignSummary} />;
};

const mapStateToProps = createSelector(
  (state) => state.campaigns,
  (state) => state.userData,
  (campaigns, userData) => ({ campaigns, userData: userData.user })
);

export default connect(mapStateToProps, bindDispatch)(CampaignSummary);
